import { Component, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ServerUrlService } from '../../../../services/server-url.service'
import { MessageChatStateService } from '../../services/message-chat-state.service'
import { ChatAttachmentEntity } from '../../interfaces/chat.interface'

@Component({
  selector: 'app-chat-lightbox',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chat-lightbox.component.html',
  styleUrl: './chat-lightbox.component.scss',
})
export class ChatLightboxComponent {
  readonly isOpen = signal(false)
  readonly currentIndex = signal(0)

  constructor(
    private state: MessageChatStateService,
    private serverUrl: ServerUrlService
  ) {}

  get images(): ChatAttachmentEntity[] {
    return this.state.chatImages()
  }

  get currentImage(): ChatAttachmentEntity | null {
    const imgs = this.images
    const idx = this.currentIndex()
    return imgs[idx] ?? null
  }

  open(attachment: ChatAttachmentEntity): void {
    const idx = this.images.findIndex((a) => a.id === attachment.id)
    this.currentIndex.set(idx >= 0 ? idx : 0)
    this.isOpen.set(true)
  }

  close(): void {
    this.isOpen.set(false)
  }

  prev(): void {
    const idx = this.currentIndex()
    if (idx > 0) this.currentIndex.set(idx - 1)
  }

  next(): void {
    const idx = this.currentIndex()
    if (idx < this.images.length - 1) this.currentIndex.set(idx + 1)
  }

  getUrl(att: ChatAttachmentEntity): string {
    return `${this.serverUrl.url}/uploads/${att.filePath}`
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('lightbox-backdrop')) {
      this.close()
    }
  }
}
